import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import DrawerCustom from '../../components/DrawerCustom';
import { Grid } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { Form, Field } from 'react-final-form';
import { TextFieldComponent} from '../../components/FormElement';
import ButtonCustom from '../../components/ButtonCustom'
import validators from '../../utils/validators';
import CustomizedCircularProgress from '../../components/CircularProgress';

const MIN_LENGTH_PASSWORD = 8;

const styles = theme => ({

    btn_save: {
        marginTop: theme.spacing(8),
    },
    inform_password: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.secondary,
        marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3)
    },
});

function ChangePassword(props){

    const {classes, t} = props
    return (
        <div>
            <DrawerCustom open={props.open} onClose={props.onClose}
                title = {t('change_password')}
                enableBack
                children={
                    <Grid xs={12} item  justify='center'>
                        {props.showLoading&&<Grid xs={12} item container justify='center' alignItems='center'>
                                                                    <CustomizedCircularProgress />
                                                                </Grid>}
                        <Form
                            onSubmit={props.onChangePassword}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                        <Field
                                            name="new_password"
                                            component={TextFieldComponent}
                                            label={t('new_password')}
                                            defaultValue={''}
                                            isEdit={true}
                                            color='default'
                                            type='password'
                                            autoFocus={true}
                                            validate={validators.composeValidators(validators.required, validators.validMinLength(MIN_LENGTH_PASSWORD))}
                                        />
                                        <Field
                                            name="confirm_password"
                                            component={TextFieldComponent}
                                            label={t('confirm_new_password')}
                                            defaultValue={''}
                                            isEdit={true}
                                            color='default'
                                            type='password'
                                            autoFocus={true}
                                            validate={validators.composeValidators(validators.validNotMatch({compareValue: values.new_password, message: t('Enter the same password')},values.confirm_password))}
                                        />
                                    <Grid item xs={12} className={classes.inform_password}>
                                        <CustomTypo color='error'>{t('inform_password')}</CustomTypo>
                                        <CustomTypo color='error'>{t('inform_password_1')}</CustomTypo>
                                        <CustomTypo color='error'>{t('inform_password_2')}</CustomTypo>
                                        <CustomTypo color='error'>{t('inform_password_3')}</CustomTypo>
                                        <CustomTypo color='error'>{t('inform_password_4')}</CustomTypo>
                                        <CustomTypo color='error'>{t('inform_password_5')}</CustomTypo>
                                    </Grid>
                                    <Grid xs={6} item container justify='center' className={classes.btn_save}>
                                        <ButtonCustom color='onPrimary' fullWidth onClick={()=>props.onClose()}>{t('btn_cancel')}</ButtonCustom>
                                    </Grid>
                                    <Grid xs={6} item container justify='center' className={classes.btn_save}>
                                        <ButtonCustom color='primary' fullWidth onClick={handleSubmit}>{t('btn_save')}</ButtonCustom>
                                    </Grid>
                                </Grid>
                            )} />
                    </Grid>}/>
        </div>
    );
}

export default withStyles(styles)(withTranslation()(ChangePassword));